import Login from 'views/pages/authentication/authentication3/Login3';

const LoginRoutes = {
    path: '/',
    element: <Login />
};

export default LoginRoutes;
